// 대화 사진 바이트 주소 — 직원은 /app 화면 주소(서명 URL 로 바꿔 쓴다) · 고객은 링크 주소(앞에 /api).

import { customerProjectPath } from "../project/customer-visible";

export const messagePhotoPath = (projectId: string, messageId: string): string =>
  `/app/projects/${encodeURIComponent(projectId)}/messages/${encodeURIComponent(messageId)}/photo`;

export const customerMessagePhotoPath = (token: string, messageId: string): string =>
  `${customerProjectPath(token)}/messages/${encodeURIComponent(messageId)}/photo`;
